<div class="imprint-data-protection-links pt-4">
  <ul
    class="d-flex flex-column list-unstyled justify-content-between align-items-center align-items-sm-start my-3"
    [ngClass]="{ 'gap-2': increasedFontSize }"
  >
    <li>
      <a
        class="link-dark pointer"
        [ngClass]="{ 'font-size-base': increasedFontSize }"
        target="_blank"
        [href]="baseStazzleLinks.IMPRINT"
      >
        {{ 'imprint' | translate }}
      </a>
    </li>
    <li>
      <a
        class="link-dark pointer"
        [ngClass]="{ 'font-size-base': increasedFontSize }"
        target="_blank"
        [href]="baseStazzleLinks.PRIVACY_POLICY"
      >
        {{ 'privacyPolicy' | translate }}
      </a>
    </li>
    <li>
      <a
        class="link-dark pointer"
        [ngClass]="{ 'font-size-base': increasedFontSize }"
        target="_blank"
        [href]="baseStazzleLinks.TERMS_OF_USE"
      >
        {{ 'termsOfUse' | translate }}
      </a>
    </li>
  </ul>
</div>
